import SpecialistServiceDetail from "@/components/SpecialistServiceDetail";

const CANCER = "https://static.prod-images.emergentagent.com/jobs/67e85589-df3b-4949-9f26-d13809d545ec/images/d3241c0f95846aabcc0c5ef1f3fdded2126a1cfc50419378de4acb64dcfd777c.jpeg";

export default function CancerCare() {
  return (
    <SpecialistServiceDetail
      testid="cancer-care-page"
      eyebrow="CANCER SUPPORT"
      title="Cancer Support"
      subtitle="Guidance, treatment support and emotional care."
      image={CANCER}
      accent="#7C3AED"
      box="#F3E8FF"
      aiPrompt="I need support understanding a cancer diagnosis and next steps."
      offerings={[
        "Oncologist consultations & expert second opinions",
        "Treatment navigation — chemo, radiation & surgery",
        "Diagnostic test coordination and report analysis",
        "Nutrition, pain & symptom management",
        "Emotional and caregiver support",
      ]}
    />
  );
}
